$(function(){
  $('.ecommerce .js-show-more-toggle').on('click', function (e) {
    const linkEl = e.currentTarget;

    if (linkEl.classList.contains('collapsed')) {
      $(`.ecommerce .js-show-more-toggle-${linkEl.dataset.targetAnalytics}`).trigger('click');
    }
  });
})
